import {
  Div, FormItem, Image, Text, Title
} from '@vkontakte/vkui';
import { INominee } from 'src/entity/Pretendents';
import { INominationCard } from '../NominationCard/NominationCard';
import styles from './styles.module.scss';

interface IWinnerCard extends INominationCard {
  winner: INominee
}

export const WinnerCard = ({ name, label, winner }: IWinnerCard) => {
  const { nomineeLabel, image } = winner;

  return (
    <FormItem key={name} className={styles.vote_card}>
      <Title className={styles.input_label} weight='3' level='2'>
        {label}
      </Title>
      <Div className={styles.winnerData}>
        <Image size={96} src={image} />
        <Text className={styles.winnerTitle} weight='2'>
          {nomineeLabel}
        </Text>
      </Div>
    </FormItem>
  );
};
